import Vue from 'vue'

// Sticky header
Vue.directive('sticky', {
	inserted: function(el) {
		window.addEventListener('scroll', () => {
			if ($(document).scrollTop() > 15) {
				el.classList.add('sticky');
			} else {
				el.classList.remove('sticky');
			}
		})
	}
})

// Sticky header
Vue.directive('sub-menu-animate', {
	inserted: function(el) {
		let lastScrollTop = 0;
		window.addEventListener('scroll', () => {
			let st = window.pageYOffset || document.documentElement.scrollTop;
			   if (st > lastScrollTop){
		      		el.classList.add('translateY');
			   } else {
		      		el.classList.remove('translateY');
			   }
			   lastScrollTop = st <= 0 ? 0 : st;
		})
	}
})


// Date format for News articles
Vue.directive('date-format', {
	bind: function (el) {},
	inserted: function (el, binding, viewOptions) {
		let date = binding.value.date.split(' ')[0].split('-').reverse().join('.')

		el.innerHTML = date
	},
	unbind: function (el) {}
})


